import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, CrossRemoveSVG, DeleteSVG, PageTitle } from '~/shared/ui'
import { ModalWindow } from '~/shared/ui/ModalWindow'
import { PropsModalWindow } from '~/shared/ui/ModalWindow/type'
import { useToast } from '~/shared/lib'
import { useStore } from '~/app/store'
import Spinner from '~/shared/ui/spinner'
import { useErrorHandler } from '~/shared/lib/hooks/use-error-handler'

export const ModalDeleteRole: FC<PropsModalWindow> = observer(
  ({ isOpen, onClose, id }) => {
    const { t } = useTranslation(['common', 'roles'])
    const toast = useToast()
    const { handleErrorWithToast } = useErrorHandler()
    const { usersStore } = useStore()
    const navigate = useNavigate()
    const { loaders, deleteRole } = usersStore

    return (
      <ModalWindow onClose={onClose} isOpen={isOpen} maxWidth>
        <div className="flex  justify-between py-3 w-[400px]">
          <PageTitle
            title={t('roles:continueDeletingRole')}
            size="text-[20px] ml-8"
          />
          <CrossRemoveSVG onChange={onClose} size="24" />
        </div>

        <div className="flex items-center justify-center p-6 space-x-2 ">
          <Button intent="secondary" onClick={onClose} type="submit">
            {t('Cancel2')}
          </Button>
          <Button
            intent="danger"
            disabled={loaders.roleDelete}
            onClick={async (e) => {
              try {
                await deleteRole(id as string)
                toast.open(t('roles:roleDeletedSuccess'), 'success')
                navigate('/settings')
              } catch (error) {
                handleErrorWithToast(error)
                navigate('/settings')
              }

              onClose(e)
            }}
          >
            {loaders.roleDelete ? <Spinner /> : <DeleteSVG color="white" />}
            {t('delete')}
          </Button>
        </div>
      </ModalWindow>
    )
  },
)
